// ============================================================================
// RUSSIAN TRANSLATIONS - FUN QUESTIONS
// ============================================================================
// Размышляющие и интересные вопросы о вере

export const funQuestions = [
  {
    question: "Какой акт любви Иисуса больше всего вдохновляет вас в повседневной жизни?",
    emoji: "❤️",
    theme: "любовь"
  },
  {
    question: "Если бы вы могли разделить трапезу с библейским персонажем, кто бы это был и почему?",
    emoji: "🍞",
    theme: "встреча"
  },
  {
    question: "Какая притча Иисуса говорит с вами наиболее глубоко и почему?",
    emoji: "🌱",
    theme: "учение"
  },
  {
    question: "Как проявляется Божий мир в вашей жизни?",
    emoji: "🕊️",
    theme: "мир"
  },
  {
    question: "Какое чудо Иисуса вы хотели бы увидеть?",
    emoji: "✨",
    theme: "вера"
  },
  {
    question: "Если бы вам нужно было описать Божью любовь одним словом, какое бы это было?",
    emoji: "💝",
    theme: "божественная любовь"
  },
  {
    question: "Какой стих из Библии помог вам в трудный момент?",
    emoji: "📖",
    theme: "утешение"
  },
  {
    question: "Как вы можете быть светом миру сегодня?",
    emoji: "💡",
    theme: "свидетельство"
  }
];

export default funQuestions;
